export default __webpack_public_path__ + "static/media/authentication_img.a4f2c55f.svg";